import { useLazyQuery, useQuery } from "@apollo/client";
import { SCANS_BY_SITE } from "../scans.queries";
import {
  ScansBySiteQuery,
  ScansBySiteQueryVariables,
} from "../../../__generated__/ScansBySiteQuery";

export const useScansBySite = (variables: ScansBySiteQueryVariables) => {
  return useQuery<ScansBySiteQuery, ScansBySiteQueryVariables>(SCANS_BY_SITE, {
    variables,
  });
};
export const useLazyScansBySite = () => {
  return useLazyQuery<ScansBySiteQuery>(SCANS_BY_SITE);
};
